import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { partners } from '../data/partners';
import { Partner } from '../model/partner.model';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    getPartner(slug: string): Observable<Partner> {
        const partner = partners[slug];
        if (partner) {
            return of(partner);
        } else {
            return throwError(() => 404);
        }
    }
}
